import React from "react";

const WhatsAppButton = () => {
  const whatsappLink =
    "https://wa.me/60182662349?text=%E4%BD%A0%E5%A5%BD%20JS%20Team,%20%E6%88%91%E4%BB%8E%E4%BD%A0%E7%9A%84%20Website%20%E6%89%BE%E5%88%B0%E8%BF%99%E4%B8%AA%E8%81%94%E7%B3%BB%E7%9A%84";

  return (
    <div className="fixed bottom-6 right-6 z-50 cursor-pointer">
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="block transition-all duration-300 hover:scale-110 hover:drop-shadow-lg"
      >
        <img
          src="/assets/img/whatsapp-button.png"
          alt="WhatsApp - Click to chat"
          className="w-64 h-auto drop-shadow-lg max-[768px]:w-48 max-[480px]:w-40"
        />
      </a>
    </div>
  );
};

export default WhatsAppButton;
